(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yhi-product-main"]) return;
  try {
    
document.addEventListener('submit', function(event) {
  if (!event.target.matches('.yhi-pair-form')) return;
  const source = event.target.closest('product-info').querySelector('product-form input[name="id"]');
  if (source) event.target.elements.id.value = source.value;
});

  } catch(e) { console.error(e); }
})();
})();
